<button class="flex items-center text-blue-500" (click)="voiceService.toggleAudio()">
  @if (voiceService.isPlaying()) {
    <i class="pi pi-pause-circle shrink-0 grow-0"></i>
  } @else {
    <i class="pi pi-play-circle shrink-0 grow-0"></i>
  }
  <span class="pl-1">Tonausgabe pausieren</span>
</button>
